export default __webpack_public_path__ + "static/media/p6.61a54c40.png";